import React from "react";
import { UserPresenter } from "../../../User/UserPresenter";
import "./AlertCodeStatus.scss";
import { IonButton, IonIcon, IonToast, IonToolbar } from "@ionic/react";
import { useDispatch } from "react-redux";
import { hasValidCode } from "../../../../store/actions/authActions";
import { helpCircleOutline } from "ionicons/icons";
import { useHistory } from "react-router";
import {useState} from 'react';

interface AlertCodeStatusProps {
  user?: UserPresenter|undefined;
}

const AlertCodeStatus = (props: AlertCodeStatusProps) => {
  const { user } = props;
  const disp = useDispatch();
  const history = useHistory();
  const [updating, setUpdating] = useState(false)
  const [showToast, setShowToast] = useState({show: false, color:"", msg:""})
  function updateCodeStatus() {
    // setShowToast(true)
    // return;
    setUpdating(true)
    disp(hasValidCode(({code, valid, rated_at}) => {
      if(code && valid){
        setShowToast({show: true, color:"success", msg:"Código validado com sucesso!"})
      } else {
        setShowToast({show: true, color:"warning", msg:"Código não foi validado com sucesso!"})
      }


    }));
  }

  if(!user || (user && user.hasValidCode() && !updating)){
    return <></>;
  }

  return (
    <div data-alert-code-status={true} className="ion-padding">
      {(user?.code.rated_at && !updating) ? (
        <div className="-ion-padding -alert -warning">
          <IonButton
            color="danger"
            expand="block"
            onClick={() => {
              history.push("/help");
            }}
          >
            <IonIcon icon={helpCircleOutline} />
            Seu código não foi validado
          </IonButton>
        </div>
      ) : (
        <div className="ion-padding alert info">
          Seu código está aguardando validação
          <IonButton
            fill="outline"
            color="dark"
            size="small"
            expand="block"
            style={{ marginTop: 10 }}
            onClick={() => updateCodeStatus()}
          >
            Atualizar
          </IonButton>
        </div>
      )}
      <IonToast
        isOpen={showToast.show}
        position="top"
        animated={true}
        color={showToast.color}
        onDidDismiss={() => {
          setShowToast({...showToast, show: false})
          setUpdating(false)
        }}
        message={showToast.msg}
        duration={4000}
      />
    </div>
  );
};

export default AlertCodeStatus;
